module.exports = __webpack_public_path__ + "static/img/info-circle.dbf56e77.svg";